export const getToken = (token: string, capitalize?: boolean) => {
  return {
    [capitalize ? 'Authorization' : 'authorization']: `Bearer ${token}`,
  };
};
